export enum RelayConnection {
  DecksForViewer = "DecksForViewer",
  ExploreDecks = "ExploreDecks",
}
